module.exports = __webpack_public_path__ + "img/middle-charging-end.d87e59de.png";